module.exports = __webpack_public_path__ + "img/20191008155842360截图20191008142958268.0af2bf2d.jpg";